import React, { useEffect, useState } from "react";
import "../assets/css/bootstrap.min.css";
import "../assets/css/style.css";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import 'leaflet-gesture-handling/dist/leaflet-gesture-handling.css';
import 'leaflet-gesture-handling';
import { motion } from "framer-motion";
import Lightbox from 'react-image-lightbox';
import { Autoplay } from 'swiper/modules';
import 'react-image-lightbox/style.css';
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { getDetalleDestino, recomendarDestino, yaRecomendoDestino, getComerciosCercanos, registrarTap } from "../api";
import { Swiper, SwiperSlide } from "swiper/react";
import toast from "react-hot-toast";
import "swiper/css";
import { useDynamicSplash } from "../hooks/useDynamicSplash";

const DestinoDetalle = () => {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [fotoActual, setFotoActual] = useState(0);
  const [loadingDestino, setLoadingDestino] = useState(true);
  const showSplash = useDynamicSplash(loadingDestino);
  const [destino, setDestino] = useState(null);
  const [lugaresRelacionados, setLugaresRelacionados] = useState([]);
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const origen = location.state?.from || "home";
  const [yaRecomendo, setYaRecomendo] = useState(false);

 

  const CirculoRadio = ({ lat, lng }) => {
    const map = useMap();
  
    useEffect(() => {
      if (!lat || !lng) return;
  
      const circle = L.circle([lat, lng], {
        radius: 600,
        color: "#3b82f6",
        fillColor: "#3b82f6",
        fillOpacity: 0.2,
      }).addTo(map);
  
      return () => {
        map.removeLayer(circle);
      };
    }, [lat, lng, map]);
  
    return null;
  };
  
  const handleRecomendar = async () => {
    const id_perfil = localStorage.getItem("id_perfil");
  
    if (!id_perfil) {
      toast.dismiss();
      toast.error("Debes tener una cuenta para poder continuar.");
      return;
    }
  
    const res = await recomendarDestino({ id_destino: destino.id_destino, id_perfil });
  
    if (res.recomendado) {
      toast.dismiss();
      toast.success("¡Gracias por tu recomendación!");
      setYaRecomendo(true);
    } else {
      toast.dismiss();
      toast.success("Has quitado tu recomendación.");
      setYaRecomendo(false);
    }
  };  

  const imagenes = destino && Array.isArray(destino.galeria)
  ? destino.galeria.map((f) => f.foto_url)
  : [];

  const abrirLightbox = (index) => {
    setFotoActual(index);
    setLightboxOpen(true);
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoadingDestino(true);
      document.body.style.overflow = "hidden";
      try {
        const data = await getDetalleDestino(id);
        setDestino(data);
      } finally {
        setLoadingDestino(false);
        document.body.style.overflow = "auto";
        window.scrollTo(0, 0);
      }
    };
    fetchData();
  }, [id]);

  useEffect(() => {
    const fetchRelacionados = async () => {
      if (!destino?.latitud || !destino?.longitud) return;
  
      const data = await getComerciosCercanos(destino.latitud, destino.longitud);
      setLugaresRelacionados(data);
    };
  
    fetchRelacionados();
  }, [destino]);

  const abrirEnlace = (tipo, url, idDestino) => {
    const id_perfil = localStorage.getItem("id_perfil");
    registrarTap(0, 'destino', '', idDestino);
    if (window.flutter_inappwebview) {
      window.flutter_inappwebview.callHandler("abrirEnlaceExterno", url);
    } else {
      window.open(url, "_blank");
    }
  };

  useEffect(() => {
    const verificarRecomendacion = async () => {
      const id_perfil = localStorage.getItem("id_perfil");
  
      if (!id_perfil || !destino || !destino.id_destino) return;
  
      const res = await yaRecomendoDestino({ id_destino: destino.id_destino, id_perfil });
      if (res.yaRecomendo) {
        setYaRecomendo(true);
      }
    };
    verificarRecomendacion();
  }, [destino]);

  if (!destino) return null;

  return (
    <>
      {showSplash && (
        <div id="splash">
          <img src="/assets/images/loading.gif" style={{ width: 300 }} alt="Cargando..." />
        </div>
      )}
      {!showSplash && (
       <motion.div
	      initial={{ y: "100%", opacity: 0 }}
	      animate={{ y: 0, opacity: 1 }}
	      exit={{ y: "100%", opacity: 0 }}
	      transition={{ duration: 0.7, ease: "easeInOut" }}
    	>
    <div className="app-container">
      <div className="connections-container">
        <div className="back-container">
          <button className="back-btn" onClick={() => {
            const volverA = location.state?.from === "all" ? "/destinos" : "/home";
            navigate(volverA);
          }}> 
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 512 512">
              <path
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="48"
                d="M244 400L100 256l144-144M120 256h292"
              />
            </svg>
          </button>
        </div>
        <h2 className="connections-title">{destino.nombre}</h2>
      </div>
      <div className="detalle-destino">
        <img className="portada-destino" src={destino.portada} alt="Portada" />
        <div className="detalle-destino-body">
            <h2 className="detalle-titulo">{destino.nombre}</h2>
            <p className="detalle-ubicacion">
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"><path d="M12.56 20.82a.96.96 0 0 1-1.12 0C6.611 17.378 1.486 10.298 6.667 5.182A7.6 7.6 0 0 1 12 3c2 0 3.919.785 5.333 2.181c5.181 5.116.056 12.196-4.773 15.64"></path><path d="M12 12a2 2 0 1 0 0-4a2 2 0 0 0 0 4"></path></g></svg>
                <b>Ubicación:</b> Municipio de {destino.municipio}.
            </p>
            <span className="city-name ubd">
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
                    <path fill="currentColor" d="m20.975 12.185l-.739-.128zm-.705 4.08l-.74-.128zM6.938 20.477l-.747.065zm-.812-9.393l.747-.064zm7.869-5.863l.74.122zm-.663 4.045l.74.121zm-6.634.411l-.49-.568zm1.439-1.24l.49.569zm2.381-3.653l-.726-.189zm.476-1.834l.726.188zm1.674-.886l-.23.714zm.145.047l.229-.714zM9.862 6.463l.662.353zm4.043-3.215l-.726.188zm-2.23-1.116l-.326-.675zm8.561 9.925l-.705 4.08l1.478.256l.705-4.08zm-6.991 9.193H8.596v1.5h4.649zm-5.56-.837l-.812-9.393l-1.495.129l.813 9.393zm11.846-4.276c-.507 2.93-3.15 5.113-6.286 5.113v1.5c3.826 0 7.126-2.669 7.764-6.357zM13.255 5.1l-.663 4.045l1.48.242l.663-4.044zm-6.067 5.146l1.438-1.24l-.979-1.136L6.21 9.11zm4.056-5.274l.476-1.834l-1.452-.376l-.476 1.833zm1.194-2.194l.145.047l.459-1.428l-.145-.047zm-1.915 4.038a8.4 8.4 0 0 0 .721-1.844l-1.452-.377A7 7 0 0 1 9.2 6.11zm2.06-3.991a.89.89 0 0 1 .596.61l1.452-.376a2.38 2.38 0 0 0-1.59-1.662zm-.863.313a.51.51 0 0 1 .28-.33l-.651-1.351c-.532.256-.932.73-1.081 1.305zm.28-.33a.6.6 0 0 1 .438-.03l.459-1.428a2.1 2.1 0 0 0-1.548.107zm2.154 8.176h5.18v-1.5h-5.18zm.581-5.641a5.5 5.5 0 0 0-.104-2.284l-1.452.377a4 4 0 0 1 .076 1.664zM8.596 21.25a.916.916 0 0 1-.911-.837l-1.494.129a2.416 2.416 0 0 0 2.405 2.208zm.03-12.244c.68-.586 1.413-1.283 1.898-2.19L9.2 6.109c-.346.649-.898 1.196-1.553 1.76zm13.088 3.307a2.416 2.416 0 0 0-2.38-2.829v1.5c.567 0 1 .512.902 1.073zm-9.122-3.168a1.583 1.583 0 0 0 1.562 1.84v-1.5a.083.083 0 0 1-.082-.098zm-5.72 1.875a.92.92 0 0 1 .316-.774l-.98-1.137a2.42 2.42 0 0 0-.83 2.04z" />
                    <path fill="currentColor" d="m3.972 21.47l-.748.066zM3 10.235l.747-.064a.75.75 0 0 0-1.497.064zm1.719 11.172L3.747 10.17l-1.494.129l.971 11.237zm-.969.107v-11.28h-1.5v11.279zm-.526.022a.263.263 0 0 1 .263-.285v1.5c.726 0 1.294-.622 1.232-1.344zm.263-.285c.146 0 .263.119.263.263h-1.5c0 .682.553 1.237 1.237 1.237z"  />
                </svg>
              {destino.recomendaciones} personas lo recomiendan.
            </span>
            {yaRecomendo && (
            <div className="recomendaste">
                <span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24">
                    <path fill="currentColor" fillRule="evenodd" d="M12 21a9 9 0 1 0 0-18a9 9 0 0 0 0 18m-.232-5.36l5-6l-1.536-1.28l-4.3 5.159l-2.225-2.226l-1.414 1.414l3 3l.774.774z" clipRule="evenodd" />
                  </svg>
                  Recomendaste este lugar
                </span>
            </div>
            )}
            {!yaRecomendo && (
              <div className="recomendacion-card">
                  <div className="recomendacion-texto">
                    <h4>¿Ya visitaste este lugar?</h4>
                    <p>Recomienda este lugar y ayudá a otros a decidir su visita.</p>
                  </div>
                  <button className="recomendacion-boton" onClick={handleRecomendar}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24"><path fill="currentColor" fillRule="evenodd" d="M12.438 2.778a.6.6 0 0 0-.438.03a.52.52 0 0 0-.28.33l-.476 1.834a8.4 8.4 0 0 1-.72 1.844c-.485.907-1.218 1.604-1.898 2.19l-1.438 1.24a.92.92 0 0 0-.315.774l.812 9.393a.916.916 0 0 0 .911.837h4.649c3.136 0 5.779-2.182 6.286-5.113l.705-4.08a.916.916 0 0 0-.901-1.073h-5.181c-.977 0-1.72-.876-1.562-1.84l.663-4.044a4 4 0 0 0-.076-1.664a.89.89 0 0 0-.596-.611zl.23-.714zm-1.09-1.321a2.1 2.1 0 0 1 1.549-.107l.145.047l-.23.714l.23-.714c.777.25 1.383.87 1.589 1.662c.193.746.229 1.524.104 2.284l-.663 4.044a.083.083 0 0 0 .082.097h5.18c1.5 0 2.636 1.352 2.38 2.829l-.705 4.08c-.638 3.688-3.938 6.357-7.764 6.357H8.596a2.416 2.416 0 0 1-2.405-2.208l-.813-9.393a2.42 2.42 0 0 1 .83-2.04l1.44-1.24c.655-.564 1.206-1.111 1.552-1.76a6.8 6.8 0 0 0 .592-1.514l.476-1.833a2.01 2.01 0 0 1 1.08-1.305m-8.38 8.028a.75.75 0 0 1 .78.685l.97 11.236a1.237 1.237 0 1 1-2.468.107V10.234a.75.75 0 0 1 .718-.75" clipRule="evenodd"/></svg>
                </button>
              </div>
            )}
            <div className="detalle-meta">
                <strong className="detalle-label">Detalles</strong>
            </div>
            <p
              className="detalle-descripcion"
              dangerouslySetInnerHTML={{ __html: destino.descripcion }}
            ></p>
            <div className="detalle-ubicacion-extra">
                <strong>{destino.nombre} en fotografías</strong>
            </div>
            <div className="detalle-destino-img">
            <Swiper modules={[Autoplay]} spaceBetween={10} loop={true} slidesPerView={1} pagination={{ clickable: true }} autoplay={{delay: 3000, disableOnInteraction: false}} style={{ height: '300px' }}>
              {destino && Array.isArray(destino.galeria) && destino.galeria.length > 0 &&
                destino.galeria.map((foto, index) => (
                  <SwiperSlide key={index}>
                    <img
                      src={foto.foto_url}
                      alt={destino.nombre || "Foto"}
                      onClick={() => abrirLightbox(index)}
                      style={{ cursor: "zoom-in" }}
                    />
                  </SwiperSlide>
                ))
              }
            </Swiper>
            {lightboxOpen && (
              <Lightbox
              toolbarButtons={[]} 
                mainSrc={imagenes[fotoActual]}
                nextSrc={imagenes[(fotoActual + 1) % imagenes.length]}
                prevSrc={imagenes[(fotoActual + imagenes.length - 1) % imagenes.length]}
                onCloseRequest={() => setLightboxOpen(false)}
                onMovePrevRequest={() =>
                  setFotoActual((fotoActual + imagenes.length - 1) % imagenes.length)
                }
                onMoveNextRequest={() =>
                  setFotoActual((fotoActual + 1) % imagenes.length)
                }
                imageTitle={`Foto ${fotoActual + 1} de ${imagenes.length}`}
              />
            )}
            </div>
            <small style={{marginTop:-18, display:"block"}}>Presiona sobre la fotografía para verla completa.</small>
            {destino?.amenidades?.length > 0 && (
            <>
              <div className="detalle-ubicacion-extra">
                <strong>Podrás encontrar:</strong>
              </div>
              <div className="amenidades-scroll">
                {destino.amenidades.map((item) => (
                  <div key={item.id_amenidad} className="amenidad-item">
                    <div
                      className="amenidad-icon"
                    >
                    <img
                      src={item.icono && item.icono !== '' ? item.icono : '/assets/images/default.png'}
                      alt={item.nombre}
                    />
                    </div>
                    <div className="amenidad-label">{item.nombre}</div>
                  </div>
                ))}
              </div>
            </>
          )}
            <div className="detalle-ubicacion-extra">
                <strong>¿Dónde está ubicado?</strong>
            </div>
            <div className="map-box">
              {Number(destino.latitud) && Number(destino.longitud) ? (
              <MapContainer center={[Number(destino.latitud), Number(destino.longitud)]} gestureHandling={true} zoom={15}
                style={{ height: "250px", width: "100%", borderRadius: "15px", marginBottom: "20px", border: "1px solid #eee"}}>
                <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png"/>
                <Marker
                  position={[Number(destino.latitud), Number(destino.longitud)]}
                  icon={L.icon({
                    iconUrl: markerIcon,
                    iconSize: [25, 41],
                    iconAnchor: [12, 41],
                  })}>
                  <Popup>{destino.nombre}</Popup>
                </Marker>
                <CirculoRadio lat={Number(destino.latitud)} lng={Number(destino.longitud)} />
              </MapContainer>
            ) : (
              <p style={{ marginTop: 20, color: "#666" }}>Ubicación no disponible para este destino.</p>
            )}
          </div>
          <div className="opciones-horizontal">
            <div className="opcion" onClick={() => abrirEnlace("waze", `https://waze.com/ul?ll=${destino.latitud},${destino.longitud}&navigate=yes`, destino.id_destino)}>
              <p>Ir con Waze</p>
              <div className="icono-circulo">
                <img src="/assets/images/waze.png" alt="Waze" />
              </div>
            </div>

            <div className="opcion" onClick={() => abrirEnlace("maps", `https://www.google.com/maps/dir/?api=1&destination=${destino.latitud},${destino.longitud}`, destino.id_destino)}>
              <p>Ir con Google Maps</p>
              <div className="icono-circulo">
                <img src="/assets/images/maps.png" alt="Google Maps" />
              </div>
            </div>
          </div>
          {Array.isArray(lugaresRelacionados) && lugaresRelacionados.length > 0 && (
          <>
          <div className="detalle-ubicacion-extra">
            <strong>¿Qué tienes cerca? <small>(a 500 metros de esta ubicación)</small></strong>
          </div>
          <div className="scroll-horizontal-section">            
            <Swiper
              className="swiper-relacionados"
              spaceBetween={10}
              slidesPerView={1.9}
              loop={true}
            >
              {lugaresRelacionados.map((lugar, i) => (
                <SwiperSlide key={lugar.id} className={i === 0 ? "primer-slide" : ""}>
                  <div className="card-lugar" onClick={() => {
                      const id_perfil = localStorage.getItem("id_perfil");
                      registrarTap(lugar.id_sucursal, "destino", id_perfil, destino.id_destino);
                      navigate(`/comercio/app/${lugar.id_sucursal}`);
                    }}>
                    <img src={lugar.portada} alt={lugar.nombre} />
                    <p>
                      <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24">
                        <path fill="#3498db" d="M10.95 12.7L9.5 11.275Q9.225 11 8.813 11t-.713.3q-.275.275-.275.7t.275.7l2.15 2.15q.3.3.7.3t.7-.3l4.25-4.25q.3-.3.287-.7t-.287-.7q-.3-.3-.712-.312t-.713.287zm-2.8 9.05L6.7 19.3l-2.75-.6q-.375-.075-.6-.387t-.175-.688L3.45 14.8l-1.875-2.15q-.25-.275-.25-.65t.25-.65L3.45 9.2l-.275-2.825q-.05-.375.175-.688t.6-.387l2.75-.6l1.45-2.45q.2-.325.55-.438t.7.038l2.6 1.1l2.6-1.1q.35-.15.7-.038t.55.438L17.3 4.7l2.75.6q.375.075.6.388t.175.687L20.55 9.2l1.875 2.15q.25.275.25.65t-.25.65L20.55 14.8l.275 2.825q.05.375-.175.688t-.6.387l-2.75.6l-1.45 2.45q-.2.325-.55.438t-.7-.038l-2.6-1.1l-2.6 1.1q-.35.15-.7.038t-.55-.438" />
                      </svg>
                      {lugar.nombre}
                    </p>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
          </>
        )}
        </div>
      </div>
    </div>
    </motion.div>
    )}
    </>
  );
};

export default DestinoDetalle;
